import styles from '../../styles/testGroupDetail/overviewEmptyCardVisual.module.scss';

function ShimmerBlock({ className = '', variant = 'default' }) {
  return <div className={`${styles.shimmerBlock} ${styles[`shimmerBlock--${variant}`]} ${className}`} aria-hidden="true" />;
}

function SummaryShimmer() {
  return (
    <div className={styles.summaryShimmer} aria-hidden="true">
      {[0, 1].map((row) => (
        <div key={row} className={styles.summaryRow}>
          <ShimmerBlock className={styles.summaryDot} variant="green" />
          <ShimmerBlock className={styles.summaryLabelBar} variant="blue" />
          <ShimmerBlock className={styles.summaryValueBar} variant="default" />
        </div>
      ))}
      <ShimmerBlock className={styles.summaryProgressBar} variant="green" />
      <ShimmerBlock className={styles.summaryCaption} variant="default" />
    </div>
  );
}

function PieShimmer() {
  return (
    <div className={styles.pieShimmer} aria-hidden="true">
      <ShimmerBlock className={styles.pieCircle} variant="purple" />
      <ShimmerBlock className={styles.pieCaption} variant="default" />
    </div>
  );
}

function LineShimmer() {
  return (
    <div className={styles.lineShimmer} aria-hidden="true">
      <ShimmerBlock className={styles.lineLegend} variant="green" />
      <div className={styles.lineChartArea}>
        {[0, 1].map((row) => (
          <ShimmerBlock key={row} className={styles.lineGridRow} variant="default" />
        ))}
        <ShimmerBlock className={styles.lineTrend} variant="green" />
      </div>
      <div className={styles.lineFooter}>
        <ShimmerBlock className={styles.lineFooterLabel} variant="default" />
        <ShimmerBlock className={styles.lineFooterValue} variant="green" />
      </div>
    </div>
  );
}

const SHIMMER_BY_TYPE = {
  summary: SummaryShimmer,
  pie: PieShimmer,
  line: LineShimmer,
};

export default function OverviewEmptyCardContent({ visualType, description }) {
  const Shimmer = SHIMMER_BY_TYPE[visualType];

  return (
    <div className={styles.container}>
      <div className={styles.shimmerWrap}>
        {Shimmer ? <Shimmer /> : null}
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
